import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ChooseAccountForLogin } from "./chooseAccntForLogin";
import { ILoginAccountTypes } from "@domains/features/LoginFlow/entities/CommonLoginData";
import { loginScreenState } from "../constant";
import DeviceContext from "@frameworks/web/components/generic/customHooks/indentifyDevice";
const accTypes = [
    { value: ILoginAccountTypes.EQ, display: "Equity" },
    { value: ILoginAccountTypes.CO, display: "Commodity" },
];
export const ClientChooseLoginAccount = (props) => {
    let navigate = useNavigate();
    const device = DeviceContext();
    const [accType, setAccType] = useState();
    const [activeClassName, setActiveClassName] = useState({ isEquity: false, isCommodity: false });
    React.useEffect(() => {
        if (accType) {
            if (accType === accTypes[0].value) {
                setActiveClassName({ isEquity: true, isCommodity: false });
            }
            else if (accType === accTypes[1].value) {
                setActiveClassName({ isEquity: false, isCommodity: true });
            }
        }
    }, [accType]);
    const submitAccountTypeFrom = (accType) => {
        if (props === null || props === void 0 ? void 0 : props.setScreenState) {
            props.setScreenState(loginScreenState.PASSWORD);
            props === null || props === void 0 ? void 0 : props.setAccType(accType);
        }
        //   navigate("/login-welcome?accType=" + accType);
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(ChooseAccountForLogin, { showNextButton: true, pageTitle: device && device.isDesktop ? "" : "Login", submitFunction: submitAccountTypeFrom, description: "Please choose which account you want to log into", disableSubmit: !accType, setAccountType: setAccType })));
};
